import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  OnChanges,
  Input,
  Output
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AdvisorIncentiveWorkshopName } from '../../../../models/_enum-collections';
import { ApiResponse } from '../../../../models/api-response.model';
import { DeclineReason } from '../../../../models/decline-reason.model';
import { EngagementDetails } from '../../../../models/engagement-details.model';
import { IncentiveDetails } from '../../../../models/incentive-details.model';
import { L1InternalStatus } from '../../../../models/l1-internal-status.model';
import { L2InternalStatus } from '../../../../models/l2-internal-status.model';
import { PmoNextStatus } from '../../../../models/pmo-next-status.model';
import { TaskOwner } from '../../../../models/task-owner.model';
import { CommonService } from '../../../common/common.service';
import { SettingsService } from '../../../common/settings.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';

@Component({
  selector: 'app-incentive-details',
  templateUrl: './incentive-details.component.html',
  styleUrls: ['./incentive-details.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class IncentiveDetailsComponent implements OnInit, OnChanges {
  @Input() incentiveDetails!: IncentiveDetails;
  @Output() refreshPartnerInput = new EventEmitter<void>();
  isReadonlyEng = true;
  btnNavEngDetails = false;
  maxYearDate!: Date;
  msgsEngDetails!: any[];
  formIncentiveDetails!: FormGroup;
  incentiveId!: number;
  taskOwnerDrpdwn!: TaskOwner[];
  pmoNextStepDrpdwn!: PmoNextStatus[];
  l1InternalStatus1!: L1InternalStatus[];
  l2InternalStatus1!: L2InternalStatus[];
  declineReason!: DeclineReason[];
  addEngagementDetails!: EngagementDetails;
  dateTime = new Date();
  yearRange = '';
  loading = false;
  isMCIWorkshop = false;
  apires!: ApiResponse;
  uname!: string;

  constructor(
    private formBuilder: FormBuilder,
    private osmEdit: OsmosisEditService,
    private commonService: CommonService,
    private settingsServices: SettingsService
  ) {
    this.onFormGroup();
  }

  ngOnInit() {
    this.incentiveId = this.incentiveDetails.requestDetailId || -1;
    this.isMCIWorkshop = this.checkMCIWorkshop(
      this.incentiveDetails.deliveryName || ''
    );

    setTimeout(() => {
      this.loading = true;
      this.loadIncentiveDetails();
    }, 3000);
  }
  ngOnChanges(): void {
    setTimeout(() => {
      this.loading = true;
      this.loadIncentiveDetails();
    }, 3000);
  }

  onFormGroup() {
    this.formIncentiveDetails = this.formBuilder.group({
      qualifiedAmount: [''],
      taskOwner: [''],
      ddpmoNextSteps: [''],
      t1InternalStatus: [''],
      opsStatus: [''],
      declineReasons: [''],
      requestDate: [''],
      day45ExpirationDate: [''],
      daysLeftFromDay45ExpirationDate: [''],
      expirationDate: [''],
      daysLeftFromExpirationDate: [''],
      cancelledDate: [''],
      fundingType: ['MSAI']
    });

    this.getTaskOwnerList();
    this.getPMONextStepsDropDown();
    this.getL1InternalStatusList();
    this.getL2InternalStatusList();
    this.getDeclineReasonList();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getTaskOwnerList() {
    this.osmEdit.getTaskOwnerDropDown().subscribe(PTList => {
      this.taskOwnerDrpdwn = PTList;
    });
  }

  getPMONextStepsDropDown() {
    this.osmEdit.getPMONextStepsDropDown().subscribe(PTList => {
      this.pmoNextStepDrpdwn = PTList;
    });
  }

  getL1InternalStatusList() {
    this.osmEdit.getL1InternalStatusDropDown().subscribe(PTList => {
      this.l1InternalStatus1 = PTList;
    });
  }

  getL2InternalStatusList() {
    this.osmEdit.getL2InternalStatusDropDown().subscribe(PTList => {
      this.l2InternalStatus1 = PTList;
    });
  }

  getDeclineReasonList() {
    this.osmEdit.getDeclineReasonDropDown().subscribe(PTList => {
      this.declineReason = PTList;
    });
  }

  loadIncentiveDetails() {
    const datePipe = new DatePipe('en-US');
    const requestDate = datePipe.transform(
      this.incentiveDetails.requestDate,
      'MM/dd/yyyy'
    );
    const day45ExpirationDate = datePipe.transform(
      this.incentiveDetails.day45ExpirationDate,
      'MM/dd/yyyy'
    );
    const expirationDate = datePipe.transform(
      this.incentiveDetails.incentiveExpirationDate,
      'MM/dd/yyyy'
    );
    const cancelledDate = datePipe.transform(
      this.incentiveDetails.cancelledDate,
      'MM/dd/yyyy'
    );

    this.formIncentiveDetails.patchValue({
      qualifiedAmount: this.incentiveDetails.qualifiedAmount,
      requestDate: requestDate,
      day45ExpirationDate: day45ExpirationDate,
      daysLeftFromDay45ExpirationDate:
        this.incentiveDetails.daysLeftFromDay45ExpirationDate,
      expirationDate: expirationDate,
      daysLeftFromExpirationDate:
        this.incentiveDetails.daysLeftIncentiveExpiration,
      cancelledDate: cancelledDate
    });

    this.formIncentiveDetails.controls['taskOwner'].setValue({
      taskOwnerId: this.incentiveDetails.taskOwnerId,
      taskOwner: this.incentiveDetails.taskOwnerName
    });

    this.formIncentiveDetails.controls['t1InternalStatus'].setValue({
      l1internalStatusId: this.incentiveDetails.l1InternalStatusId,
      l1internalStatus: this.incentiveDetails.l1InternalStatusName
    });

    this.formIncentiveDetails.controls['opsStatus'].setValue({
      l2internalStatusId: this.incentiveDetails.opsStatusId,
      l2internalStatus: this.incentiveDetails.l2InternalStatusName
    });

    this.formIncentiveDetails.controls['ddpmoNextSteps'].setValue({
      pmonextStepId: this.incentiveDetails.pmoNextStepId,
      pmoNextStepName: this.incentiveDetails.pmoNextStepName
    });

    this.formIncentiveDetails.controls['declineReasons'].setValue({
      declineReasonId: this.incentiveDetails.declineReasonsId,
      declineReason: this.incentiveDetails.declineReasonName
    });

    this.loading = false;
  }

  editIncentiveDetails() {
    this.isReadonlyEng = false;
    this.btnNavEngDetails = true;
    this.msgsEngDetails = [];
  }

  editIncentiveDetailsCancel() {
    this.isReadonlyEng = true;
    this.btnNavEngDetails = false;
    this.msgsEngDetails = [];
    this.loadIncentiveDetails();
  }

  checkMCIWorkshop(incentiveSubtype: string): boolean {
    switch (incentiveSubtype.toLowerCase()) {
      case AdvisorIncentiveWorkshopName.Frontline_Worker_MCI.toLowerCase():
        return true;
      case AdvisorIncentiveWorkshopName.Microsoft_Viva_MCI.toLowerCase():
        return true;
      default:
        return false;
    }
  }

  onSubmitIncentiveDetails(formIncentive: FormGroup) {
    if (formIncentive.status == 'VALID') {
      this.uname = this.settingsServices.AliasName || '';

      this.addEngagementDetails = {
        requestDetailId: this.incentiveId,
        qualifiedAmount:
          this.formIncentiveDetails.controls['qualifiedAmount'].value,
        taskOwnerId:
          this.formIncentiveDetails.controls['taskOwner'].value.taskOwnerId !=
          null
            ? this.formIncentiveDetails.controls['taskOwner'].value.taskOwnerId
            : null,
        taskOwnerName:
          this.formIncentiveDetails.controls['taskOwner'].value.taskOwner,
        pmonextStepId:
          this.formIncentiveDetails.controls['ddpmoNextSteps'].value
            .pmonextStepId != null
            ? this.formIncentiveDetails.controls['ddpmoNextSteps'].value
                .pmonextStepId
            : null,
        pmonextStepName:
          this.formIncentiveDetails.controls['ddpmoNextSteps'].value
            .pmoNextStepName,
        l1internalStatusId:
          this.formIncentiveDetails.controls['t1InternalStatus'].value
            .l1internalStatusId != null
            ? this.formIncentiveDetails.controls['t1InternalStatus'].value
                .l1internalStatusId
            : null,
        l1internalStatusName:
          this.formIncentiveDetails.controls['t1InternalStatus'].value
            .l1internalStatus,
        opsStatusId:
          this.formIncentiveDetails.controls['opsStatus'].value
            .l2internalStatusId != null
            ? this.formIncentiveDetails.controls['opsStatus'].value
                .l2internalStatusId
            : null,
        l2internalStatusName:
          this.formIncentiveDetails.controls['opsStatus'].value
            .l2internalStatus,
        declineReasonsId:
          this.formIncentiveDetails.controls['declineReasons'].value
            .declineReasonId != null
            ? this.formIncentiveDetails.controls['declineReasons'].value
                .declineReasonId
            : null,
        declineReasonName:
          this.formIncentiveDetails.controls['declineReasons'].value
            .declineReason,
        lastUserAlias: this.uname
      } as any;

      this.osmEdit.addIncentiveDetails(this.addEngagementDetails).subscribe(
        messageResponse => {
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.refreshPartnerInput.emit();
            this.msgsEngDetails = [];
            this.msgsEngDetails.push({
              severity: 'success',
              detail: 'Engagement Details Saved Successfully.'
            });
            this.isReadonlyEng = true;
            this.btnNavEngDetails = false;
          }
          if (this.apires.success === false) {
            this.msgsEngDetails = [];
            this.msgsEngDetails.push({
              severity: 'error',
              detail: this.apires.message
            });
          }
        },
        error => {
          this.msgsEngDetails = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgsEngDetails.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgsEngDetails.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Adding Engagement Details'
            });
          }
        }
      );
    }
  }
}
